import * as actionTypes from "./actionTypes";
import axios from "axios";
import endpoint from "../../utility/endpoints";
import router from "next/router";
import { sessionTimeOutCheck, checkExpiry } from "../global/actions";
import endpoints from "../../utility/endpoints";

export const getBotsAction = (botIndex) => {
  // console.log(botIndex, "botindex in action")

  return async function (dispatch) {
    
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      return axios({
        method: "get",
        url: `${endpoint.baseUrl}/elastic/searchQuery`,
        params: {
          botIndex: botIndex,
          status: "Live",
        },
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((response) => {
        if (response.data.code == 200) {
          dispatch(
            saveBotsAction({
              data: response.data.data,
              filter: false,
              botIndex: botIndex,
            })
          );
        } else if (response.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          dispatch(sessionTimeOutCheck(true));
        } else {
          dispatch(getBotsFailed());
        }
      });
    } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};

export const getFilterBotsAction = (botIndex, Filters) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  return async function (dispatch) {
    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await checkExpiry(authCheck);
       if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        return axios({
        method: "get",
        url: `${endpoint.baseUrl}/elastic/searchQuery`,
        params: { ...Filters, botIndex: botIndex },

        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((resp) => {
        if (resp.data.code == 200) {
          dispatch(
            saveBotsAction({
              data: resp.data.data,
              filter: true,
              botIndex: botIndex,
            })
          );
        } else if (resp.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          // router.push("/login");
          dispatch(sessionTimeOutCheck(true));
        } else {
          dispatch(getBotsFailed());
        }
      });
    } else {
      dispatch(sessionTimeOutCheck(true));
    }
  };
};

export const getBotsFailed = () => {
  return {
    type: actionTypes.getBotsFailed,
  };
};

export const saveBotsAction = (payload) => {
  return {
    type: actionTypes.saveBotsActionType,
    payload: payload,
  };
};

// to save the bot that user clicked on

export const saveCurrentBot = (payload) => {
  console.log("at action");
  return {
    type: actionTypes.saveCurrentBotActionType,
    payload: payload,
  };
};

export const currentBotEditedStateAction = (payload) => {
  console.log(payload, "currentBotEditedState");
  return {
    type: actionTypes.editCurrentBotActionType,
    payload: payload,
  };
};
